// apps/app/src/state/channels/channels.ts
import { createMemo, createResource } from 'solid-js'
import { userId } from '../auth'
import { handleGetChannelsWithMeta } from './resources'

export function useChannels() {
  const [channelsResource, { refetch: refetchChannels, mutate: mutateChannels }] = createResource(
    userId,
    handleGetChannelsWithMeta,
    { initialValue: [] }
  )

  // NEW: A highly efficient derived signal that turns the array into a boolean
  const hasUnreadChats = createMemo(() => {
    const channels = channelsResource()
    if (!channels) return false

    // Returns true the moment it finds a channel with unreads
    return channels.some((c) => (c.unread_count || 0) > 0)
  })

  return {
    channelsResource,
    refetchChannels,
    mutateChannels,
    hasUnreadChats, // Export our new boolean
  }
}
